export default Object.freeze({
  // PROMOTION_COUPON_
  DATE: '일',
  COUPON: '할인쿠폰',
  COUPON2: '쿠폰',
  COUPON_TYPE: '혜택구분',
  COUPON_TYPE_PRODUCT: '상품 금액 할인',
  COUPON_TYPE_CART: '장바구니 금액 할인',
  COUPON_ISSUANCE_PERIOD: '쿠폰발행 기간',
  STATUS_TYPE: '쿠폰상태',
  STATUS_TYPE_ISSUE_READY: '발급대기',
  STATUS_TYPE_ISSUE_ING: '발급 중',
  STATUS_TYPE_ISSUE_STOP: '발급중지',
  STATUS_TYPE_ISSUE_END: '발급종료',
  ISSUE_TYPE: '발급 유형',
  ISSUE_TYPE_DOWNLOAD: '다운로드 발급',
  ISSUE_TYPE_CODE_DESIGNATE: '지정코드 발급',
  ISSUE_TYPE_CODE_RANDOM: '난수코드 발급',
  ISSUE_TYPE_INSERT: '인서트 발급',
  NO_LIMIT: '제한없음',
  CANT_USED: '사용불가',
  LIMIT_BY_PRODUCT_AMT: '상품 금액 기준',
  LIMIT_BY_CART_AMT: '장바구니 금액 기준 ',
  PLATFORM_TYPE_PC: 'PC',
  PLATFORM_TYPE_MOBILE_WEB: '모바일 웹',
  PLATFORM_TYPE_MOBILE_APP: '모바일 앱',
  TARGET_TYPE_ALL_PRODUCT: '전상품',
  TARGET_TYPE_PRODUCT: '개별상품',
  TARGET_TYPE_BRAND: '브랜드',
  TARGET_TYPE_CATEGORY: '카테고리',
  TARGET_TYPE_PARTNER: '파트너사',
  GUIDE: '안내',

  SALES_STATISTICS: '판매통계',
  TAB_PERIOD: '기간별 판매현황',
  TAB_PRODUCT: '상품 판매현황',
  TAB_CATEGORY: '카테고리 판매현황',
  CLAIM: '클레임',
  DIVISION: '구분',
  EXCEPT: '제외',
  INCLUDE: '포함',
  CLAIM_EXCEPT: '결제(입금)완료 건만 조회',
  CLAIM_INCLUDE:
    '결제(입금)완료 – 취소완료(환불완료) – 반품완료(환불완료) – 교환완료(환불완료) - 교환완료(결제완료) - 교환완료',
  NUMBER_SALES: '판매건수 : 클레임 포함 조회시 부분취소(반품)일 경우 판매(주문)건수에는 포함되지 않습니다.',
  SALE_PRICE_A: '판매금액(A) : 판매가 – 즉시할인가',
  PROMOTIONAL_PRODUCT_DISCOUNT_B: '프로모션 상품할인금액(B) : 추가 할인금액 + 상품 금액 할인',
  TOTAL_PRODUCT_SALES_C: '총 상품판매금액(C) : 판매금액(A) - 프로모션 상품할인금액(B)',
  EXCEL_DOWNLOAD_1:
    '※ 엑셀다운로드 : 조회조건에 따른 엑셀 다운로드시 해당 상품/옵션이 포함된 주문 건이 다운로드됩니다.(주문번호 기준)',
  EXCEL_DOWNLOAD_2:
    '회원그룹으로 조회 시,복수 회원그룹을 가진 회원의 데이터가 이중 집계되어 오차가 발생할 수 있습니다.',
  PARTNER: '파트너 ',
  MEMBER_TYPE: '회원유형',
  MEMBER_SHIP_GENDER: '회원성별',
  MALE: '남성',
  FEMALE: '여성',
  UNCLASSIFIED: '미분류',
  MEMBER_SHIP_LEVEL: '회원등급',
  MEMBER_GROUP: '회원그룹',
  CLAIM_CLASSIFICATION: '클레임구분',
  SELECT_FALSE: '클레임제외',
  SELECT_TRUE: '클레임포함',
  STANDARD_CATEGORY: '표준카테고리',
  TERM: '기간',

  // detail
  ADD_COUPON: '할인쿠폰 등록',
  ADD_CONFIRM: '할인쿠폰 등록을 완료 하시겠습니까?',
  ADD_SUCCESS: '생성되었습니다.',
  ADD_CANCEL_CONFIRM: '등록을 취소하고 목록으로 이동하시겠습니까?\n입력하신 내용은 저장되지 않습니다.',
  EDIT_MALL_CONFIRM: '쇼핑몰을 수정하실 경우 쿠폰이 적용 된 할인 대상은 초기화 됩니다.\n수정 하시겠습니까?',
  // BasicInfo
  REGIST: '등록',
  MODIFY: '수정',
  BASIC_INFO: '기본정보',
  NAME: '쿠폰명',
  NAME_PLACEHOLDER: '쿠폰명 입력',
  REASON: '쿠폰 사유',
  REASON_PLACEHOLDER: '쿠폰사유 입력',
  ISSUE_LIMIT_CNT: '쿠폰발행 수량',
  USE_STATUS: '발급/사용 현황',
  ISSUANCE_STATUS: '발급현황',
  ISSUE_TODAY: '오늘발급',
  USAGE_STATUS: '사용현황',
  DETAIL_STATUS_BTN: '사용현황 상세보기',
  // ChannelConfig
  CHANNEL_CONFIG: '채널설정',
  CHANNEL_LIMIT: '발급/사용 채널 제한',
  CHANNEL_LIMIT_GUIDE_1:
    '가격비교사이트 등 외부 채널을 통해 상품상세에 유입된 경우, 채널별로 할인 쿠폰의 다운로드 및 사용을 제한하기 위한 기능입니다.',
  CHANNEL_LIMIT_GUIDE_2:
    '네이버쇼핑, 페이스북 카탈로그, 다나와, 에누리, 쿠차, 위메프원더쇼핑의 경우 EP 생성 시 상품상세 URL에 채널타입에 대한 코드값을 포함하여 생성됩니다.',
  CHANNEL_LIMIT_GUIDE_3:
    '상품상세 URL에 채널타입에 대한 코드값을 직접 입력한 경우, 채널 추가 입력을 통해 URL에 추가한 코드값을 직접 입력하여 쿠폰 발급이 가능한 채널을 설정할 수 있습니다.',
  USE: '사용함',
  NOT_USE: '사용안함',
  ALL_SELECT: '전체선택',
  NAVER_SHOPPING: '네이버쇼핑',
  FACEBOOK_CATALOG: '페이스북 카탈로그',
  DANAWA: '다나와',
  ENURI: '에누리',
  COOCHA: '쿠차',
  WEMAKEPRICE: '위메프원더쇼핑',
  ADD_CHANNEL_INPUT: '채널 추가 입력',
  ADD_CHANNEL_PLACEHOLDER: '채널타입 코드값을 입력해주세요. (복수 입력 시 ,(콤마) 또는 엔터(Enter)로 구분)',
  // IssueInfo
  ISSUE_INFO: '발급정보',
  ISSUE_TYPE_GUIDE: '발급유형 안내',
  ISSUE_TYPE_GUIDE_1: '다운로드 발급 : 고객이 직접 버튼을 클릭하여 발급받는 발급유형',
  ISSUE_TYPE_GUIDE_2: '지정코드 발급 : 고객이 주문서에서 직접 문자열을 입력하여 할인적용 받는 발급유형',
  ISSUE_TYPE_GUIDE_3: '난수코드 발급 : 고객이 쿠폰번호 입력 페이지에서 랜덤 문자열을 입력하여 발급받는 발급유형',
  ISSUE_TYPE_GUIDE_4: '인서트 발급 : 고객의 액션 없이 고객의 쿠폰함으로 직접 발급해 주는 발급유형',
  MEMBER_TARGET: '발급 대상 회원',
  GRADE_ALL: '전체등급',
  PROMOTION_CODE: '프로모션코드',
  ISSUE_TIME: '발급시간대',
  ISSUE_TIME_N: '시간대설정안함',
  ISSUE_TIME_Y: '시간대설정:',
  DAILY_ISSUE_LIMIT: '1일 발급 제한',
  LIMIT_N: '발급 무제한',
  LIMIT_Y: '발급 제한:',
  PER_PERSON_LIMIT: '1인당 발급 제한',
  ISSUE_PER_PERSON_LIMIT: '기간전체발급제한',
  DAILY_ISSUE_PER_PERSON_LIMIT: '1일발급제한',
  COUPON_ISSUE_LIMIT_TYPE: '상품상세 노출 여부',
  COUPON_ISSUE_LIMIT_TYPE_GUIDE: '상품상세 노출 제한 안내',
  COUPON_ISSUE_LIMIT_TYPE_GUIDE_INFO:
    '상품상세 미노출을 설정하면 상품상세 페이지에 쿠폰이 노출되지 않습니다. 이 기능은 기획전 등 특정 페이지에서만 쿠폰이 노출되도록 하고 싶을 때 활용할 수 있습니다.',
  COUPON_ISSUE_LIMIT_TYPE_NO_LIMIT: '노출',
  COUPON_ISSUE_LIMIT_TYPE_PRODUCT_DETAIL: '미노출',
  ISSUE_PLATFORM: '발급가능 플랫폼',
  POSSIBLE_DAYS_OF_WEEK: '발급가능 요일',
  REGISTER_PER_PERSON_LIMIT: '1인당 등록가능 수량',
  CODE_LENGTH: '난수 자리수',
  CODE_LENGTH_TYPE_1: '지정 자리수',
  CODE_LENGTH_8: '8자리',
  CODE_LENGTH_12: '12자리',
  CODE_LENGTH_16: '16자리',
  CODE_LENGTH_TYPE_2: '자리수 입력',
  RANDOM_CODE_GENERATION: '난수코드 생성',
  RANDOM_CODE_GENERATION_BTN: '엑셀 다운로드',
  CODE_RANDOM: '난수코드 생성',
  CODE_RANDOM_TEXT: '등록 후 엑셀파일 다운로드 가능합니다. 먼저 등록절차를 완료 해 주세요.',
  // AmountInfo
  AMOUNT_INFO: '금액설정',
  MIN_LIMIT: '최소 기준 금액',
  MAX_LIMIT: '최대 기준 금액',
  DISCOUNT_AMOUNT: '할인 금액',
  FIXED: '정액',
  CONSTANT: '정률',
  COST_SHARING: '비용분담 설정',
  SERVICE_SHARE: '쇼핑몰 부담',
  PARTNER_SHARE: '파트너 부담',
  RESERVE_LIMIT: '적립금 제한',
  RESERVE_LIMIT_GUIDE: '적립금 제한 안내',
  RESERVE_LIMIT_GUIDE_INFO:
    '적립금 제한으로 설정 된 쿠폰을 주문 건에 적용 할 경우 구매자가 상품 구매 시 적립받도록 설정 된 적립금이 적립되지 않는 기능입니다.',
  EXCLUDING_EARNING: '적립금 적립 제외',
  USE_OTHER: '상품쿠폰 사용',
  // TargetInfo
  TARGET_INFO: '대상 설정',
  DISCOUNT_TARGET: '할인 대상',
  EXCLUDE_TARGET: '할인 대상 제외 설정',
  EXCLUDE_TARGET_NOT_SET: '설정 안함',
  EXCLUDE_TARGET_SET: '설정',
  BRAND_SEARCH: '브랜드명 검색',
  SELECTED_CATEGORY: '선택한 카테고리',
  ENTER_PARTNER_NAME: '파트너명 입력',
  CLICK_TARGET_CONFIRM: '쿠폰할인 대상을 수정하시면 현재 설정된 내용이 초기화됩니다. 계속진행하시겠습니까?',
  // ProductGrid
  PRODUCT_TITLE: '할인쿠폰 적용 상품',
  PRODUCT_TARGET_GUIDE_1:
    '파트너 미동의 : 파트너사 프로모션 동의 안 함인 경우 (파트너센터 기초정보관리에서 설정변경 가능)',
  PRODUCT_TARGET_GUIDE_2:
    '프로모션 불가상품 : 상품의 프로모션 설정 값 중 \'쿠폰\'이 선택되지 않은 경우 (상품수정에서 설정변경 가능)',
  PRODUCT_TARGET_GUIDE_3: '금액조건 불가 : 상품이 할인 금액조건에 맞지 않는 가격일 경우',
  PRODUCT_TARGET_GUIDE_4: '등록불가 상품상태 : 상품 상태가 판매종료, 판매금지, 삭제요청, 등록대기인 경우',
  REMOVE_PRODUCT_BTN: '선택상품 삭제',
  ADD_PRODUCT: '상품조회',
  UPLOAD_EXCEL_BTN: '엑셀일괄등록',
  UPLOAD_EXCEL_FORM_BTN: '엑셀양식 다운로드',
  PRODUCT_SEARCH_POP: '할인쿠폰 상품 추가',
  NO_TARGET_PRODUCT: '대상 상품이 없습니다.',
  NO_REGISTERED_PRODUCT: '등록된 제외 상품이 없습니다.',
  ADD_PRODUCT_MAG: '추가 되었습니다. 성공 {0}건 실패 {1}건',
  SALE_METHOD_TYPE_PURCHASE: '사입',
  SALE_METHOD_TYPE_CONSIGNMENT: '위탁',
  NOT_CHECK_PRODUCT: '상품쿠폰에서 삭제 할 상품을 선택 해 주세요.',
  REMOVE_PRODUCT_CONFIRM: '선택하신 상품에 적용 된 상품 쿠폰을 삭제 하시겠습니까?',
  EXCEL_UPLOAD_CONFIRM: '엑셀파일을 다시 업로드를 하실 경우 기존 할인대상 리스트는 초기화 됩니다.\n계속하시겠습니까?',
  ERR_FILE_TYPE: '엑셀파일만 등록해주세요',
  EXCEL_NO_DATA: '제공되는 엑셀 양식에 정확히 데이터를 입력 후 업로드 해주세요.',
  EXCEL_UPLOAD_MSG: '업로드가 완료되었습니다. 성공 {0}건 실패 {1}건',
  EXCEL_FAIL: '실패',
  EXCEL_SUCCESS: '성공',
  EXCEL_HAVE_NO: '중복된 상품번호',
  EXCEL_NOT_FIND: '존재하지 않는 상품번호',
  EXCEL_RESULT: '등록결과',
  EXCEL_REASON: '사유',

  // ExcludeProdGrid
  EXCLUDE_TITLE: '할인 대상 제외 상품',
  EXCLUDE_TARGET_GUIDE_1: '할인 대상 제외 상품은 해당 ‘할인쿠폰’ 이 적용되지 않습니다.',
  EXCLUDE_TARGET_GUIDE_2: '할인 대상 제외 상품 중 ‘직접 삭제’ 한 상품은, ‘할인 대상 상품’ 으로 설정됩니다.',
  EXCLUDE_TARGET_GUIDE_3: '발급 시작 후 할인 쿠폰의 제외 상품 설정이 가능합니다.',
  ADD_EXCLUDE_PRODUCT: '할인 대상 제외 상품조회',
  DEL_EXCLUDE_CONFIRM: '제외 상품 삭제 시, 할인대상 상품으로 설정됩니다. 삭제 하시겠습니까?',
  CATEGORY_INFO_POP: '전시카테고리 추가정보',
  EXCEL_EXCLUDE_UPLOAD_CONFIRM:
    '엑셀파일을 다시 업로드 하실 경우 기존 할인대상 제외 리스트는 초기화 됩니다. \n계속 하시겠습니까?',
  EXCEL_DIFF_BRAND: '브랜드 정보 상이',
  EXCEL_DIFF_PARTNER: '파트너 정보 상이',
  EXCEL_DIFF_CATEGORY: '카테고리 정보 상이',

  // DeletedProdGrid
  DELETED_TITLE: '할인쿠폰 삭제 상품',
  DELETED_TARGET_GUIDE_1:
    '파트너 미동의 : 파트너사 프로모션 동의 안 함인 경우 (파트너센터 기초정보관리에서 설정변경 가능)',
  DELETED_TARGET_GUIDE_2:
    '프로모션 불가상품 : 상품의 프로모션 설정 값 중 \'쿠폰\'이 선택되지 않은 경우 (상품수정에서 설정변경 가능)',
  DELETED_TARGET_GUIDE_3: '등록불가 상품상태 : 상품 상태가 판매종료, 판매금지, 삭제요청, 등록대기인 경우',
  STATUS_ENUM_PARTNER_DISAGREE: '파트너사 프로모션 미동의',
  STATUS_ENUM_PROMOTION_NOT_ALLOWED: '프로모션 불가설정 상품',
  STATUS_ENUM_REGISTER_NOT_ALLOWED: '등록대기/판매불가 상품',

  // UseInfo
  USE_INFO: '사용 설정',
  USABLE_PLATFORM: '사용가능 플랫폼',
  PERIOD_OF_USE: '사용가능 기간',
  PERIOD_OF_USE_GUIDE: '쿠폰 사용가능 기간 안내',
  PERIOD_OF_USE_GUIDE_1:
    '‘쿠폰을 발급받은 날부터 ~까지 사용가능’ 으로 설정한 경우, 종료일의 23:59까지 사용 가능합니다.',
  PERIOD_OF_USE_GUIDE_2: '예) 쿠폰을 발급받은 날부터 [+3일]까지 사용가능',
  PERIOD_OF_USE_GUIDE_3: '- 발급일: 04/01 01:00 발급 => 04/04 23:59까지 사용가능',
  PERIOD_OF_USE_GUIDE_4: '- 발급일: 04/01 23:00 발급 => 04/04 23:59까지 사용가능',
  USE_DAY_TYPE: '쿠폰을 발급받은 날부터',
  USE_END_YMDT_TYPE: '특정 날짜 지정',
  CAN_BE_USED_UNTIL: '까지 사용가능',
  SELECT_PERIOD: '기간 선택',
  TODAY: '당일',
  LATER_1_DAYS: '+1일',
  LATER_3_DAYS: '+3일',
  LATER_7_DAYS: '+7일',
  LATER_15_DAYS: '+15일',
  LATER_30_DAYS: '+30일',
  MONTH_END_DAY: '해당월 말일',
  LATER_DAYS: '+{0}일',
  AVAILABLE_PAY_TYPE: '사용가능 결제수단',
  PAY_TYPE_OF_USE_GUIDE: '선택된 결제수단으로 결제하는 경우에만 할인쿠폰 사용이 가능합니다.',
  ALL_AVAILABLE: '전체가능',
  PAY_TYPE_SETTING: '설정',
  PAY_TYPE_PAYCO: 'PAYCO',
  PAY_TYPE_NAVER_EASY_PAY: '네이버페이',
  PAY_TYPE_CREDIT_CARD: '신용카드',
  PAY_TYPE_REALTIME_ACCOUNT_TRANSFER: '실시간계좌이체',
  PAY_TYPE_VIRTUAL_ACCOUNT: '가상계좌',
  PAY_TYPE_ESCROW_REALTIME_ACCOUNT_TRANSFER: '실시간계좌이체-에스크로',
  PAY_TYPE_ESCROW_VIRTUAL_ACCOUNT: '가상계좌-에스크로',
  // edit
  DESC1: '\'할인 대상\'에 포함된 상품만 조회됩니다.',
  DESC2: '이미 ‘할인 대상 제외’ 된 상품은 조회되지 않습니다.',
  EDIT_COUPON: '변경사항 저장',
  EDIT_CONFIRM: '변경사항을 저장하시겠습니까?',
  EDIT_CANCEL_CONFIRM: '쿠폰 수정을 취소하시겠습니까? 수정하신 내용은 저장되지 않습니다.',
  EDIT_SUCCESS: '수정되었습니다.',
  ISSUE_STOP_BTN: '발급일시중지',
  ISSUE_STOP_CONFIRM: '쿠폰 발급을 일시적으로 중지하시겠습니까?',
  ISSUE_STOP_RESULT: '쿠폰 발급이 일시중지 되었습니다.',
  ISSUE_ING_BTN: '발급재시작',
  IS_COUNT_OVER: '쿠폰 수량이 만료되어 발급을 재시작할 수 없습니다.',
  IS_PERIOD_END: '쿠폰 발행기간이 만료되어 발급을 재시작할 수 없습니다.',
  ISSUE_ING_CONFIRM: '쿠폰 발급을 재시작하겠습니까?',
  ISSUE_ING_RESULT: '쿠폰 발급이 재시작 되었습니다.',
  ISSUE_END_BTN: '발급종료',
  ISSUE_END_CONFIRM: '쿠폰 발급을 종료하시겠습니까?',
  ISSUE_END_RESULT: '쿠폰발급이 종료되었습니다.',

  // list
  LIST: '관리',
  TAB_LIST: '할인쿠폰 발행 관리',
  TAB_ISSUE: '할인쿠폰 지급 관리',
  SEARCH_KEYWORD_TYPE: '검색어',
  SEARCH_KEYWORD_TYPE_NAME: '쿠폰명',
  SEARCH_KEYWORD_TYPE_NO: '쿠폰번호',
  SEARCH_KEYWORD_TYPE_ADMIN: '등록자',
  TERM_REGISTER_YMD: '등록일',
  TERM_ISSUE_START_YMD: '발행시작일',
  TERM_ISSUE_END_YMD: '발행종료일',
  CHECK_ONLYNUM_ERR: '숫자만 입력 가능합니다.',
  MIN_SALE_HELP_1: '할인쿠폰 등록/수정 시, 설정된',
  MIN_SALE_HELP_2: '\'최소 기준 금액\'',
  MIN_SALE_HELP_3: '입니다. (단위: 원)',
  MIN_SALE_HELP_4: '\'장바구니 배송비 할인\'',
  MIN_SALE_HELP_5: '쿠폰은,',
  MIN_SALE_HELP_6: '장바구니 금액',
  MIN_SALE_HELP_7: '과',
  MIN_SALE_HELP_8: '배송비 금액',
  MIN_SALE_HELP_9: '이 각각 표시됩니다.',
  SERVICE_SHARE_RATE_HELP_1: '상품 금액 할인 / 상품 금액할인(플러스)',
  SERVICE_SHARE_RATE_HELP_2: '할인쿠폰 \'비용분담 설정\' 시 \'쇼핑몰 부담\'으로 설정된 비율(%) 입니다.',
  SERVICE_SHARE_RATE_HELP_3: '장바구니 금액 할인 / 장바구니 배송비 할인',
  SERVICE_SHARE_RATE_HELP_4: '쇼핑몰에서 100% 비용을 부담하는 할인 쿠폰입니다.',
  END_STATUS_HELP: '상태 안내',
  END_STATUS_HELP_1: '발행수량보다 발급수량이 더 많아 나타나는 아이콘입니다.',
  END_STATUS_HELP_2: '쿠폰의 설정값을 다시 확인해주세요.',

  // grid header
  HEADER_NO: '쿠폰번호',
  HEADER_STATUS_TYPE: '쿠폰상태',
  HEADER_COUPON_NAME: '쿠폰명',
  HEADER_COUPON_TYPE: '혜택구분',
  HEADER_MIN_SALE_PRICE: '최소기준금액',
  HEADER_MAX_SALE_PRICE: '최대기준금액',
  HEADER_DISCOUNT_AMT: '할인금액',
  HEADER_SERVICE_SHARE_RATE: '쇼핑몰 비용부담',
  HEADER_ISSUE_TYPE: '발급유형',
  HEADER_ISSUE_LIMIT_CNT: '발행수량',
  HEADER_TOTAL_ISSUE_CNT: '발급현황',
  HEADER_TOTAL_USE_CNT: '사용현황',
  HEADER_ISSUE_START_YMDT: '쿠폰발행시작일',
  HEADER_ISSUE_END_YMDT: '쿠폰발행종료일',

  HEADER_MALL_PRODUCT_NO: '상품번호',
  HEADER_PRODUCT_NAME: '상품명',
  HEADER_PRODUCT_MANAGEMENT_CD: '상품관리코드',
  HEADER_SALE_METHOD_TYPE: '판매방식',
  HEADER_PARTNER_NAME: '파트너명',
  HEADER_COMMISSION_RATE: '수수료율',
  HEADER_SUPPLY_PRICE: '공급가',
  HEADER_PURCHASE_PRICE: '매입가',
  HEADER_APPLY_DISCOUNT_SALE_PRICE: '판매가/<br>할인적용가',
  HEADER_APPLY_DISCOUNT_SALE_PRICE2: '판매가/할인적용가',
  HEADER_ADDITIONAL_DISCOUNT_AMOUNT: '추가할인',
  HEADER_APPLY_ADDITIONAL_DISCOUNT_SALE_PRICE: '추가할인<br>적용가',
  HEADER_APPLY_COUPON_DISCOUNT_SALE_PRICE: '쿠폰<br>적용가',
  HEADER_COUPON_REGISTER_YMDT: '추가일',
  HEADER_BRAND_NAME: '브랜드',
  HEADER_DISPLAY_CATEGORY_FULL_NAME: '전시카테고리',
  HEADER_DISCOUNT_AMOUNT: '추가할인적용가',
  HEADER_STATUS_ENUM: '삭제사유',

  // error message
  ERR_NO_CHANNEL_USED: '쿠폰 발급/사용 채널을 선택해주세요.',
  ERR_COUPONNAME_NULL: '쿠폰명을 입력해 주세요.',
  ERR_ISSUELIMITCNT_NULL: '발급 수량을 입력 해주세요.',
  ERR_ISSUELIMITCNT_0: '발급 수량은 0으로 입력할 수 없습니다.',
  ERR_ISSUETIME: '발급 종료 시간은 시작시간보다 미래로 설정해주세요.',
  ERR_REGISTERPERPERSON_NULL: '1인당 등록가능 수량을 입력하세요',
  ERR_REGISTERPERPERSON_0: '1인당 등록가능수량을 0으로 입력하실 수 없습니다.',
  ERR_REGISTERPERPERSON_BETWEEN: '1인당 등록가능수량을 전체쿠폰발행수량 이하로 입력 해 주세요',
  ERR_COUPONCODELENGTH_NULL: '난수 자리수를 입력하세요',
  ERR_COUPONCODELENGTH_GREATERTHEN: '난수쿠폰은 5자리 미만으로 설정할 수 없습니다.',
  ERR_COUPONCODELENGTH_LESSTHEN: '난수쿠폰은 20자리를 초과하도록 설정할 수 없습니다.',
  ERR_PROMOTIONCODE_NULL: '프로모션 코드를 입력하세요',
  ERR_DAILYISSUELIMIT_NULL: '1일 발급 제한 수량을 입력하세요.',
  ERR_DAILYISSUELIMIT_0: '1일 발급제한 수량은 0으로 입력할 수 없습니다.',
  ERR_DAILYISSUELIMIT_BETWEEN: '1일 발급제한 수량을 쿠폰발행수량 이하로 입력 해 주세요',
  ERR_ISSUEPERPERSONLIMIT_NULL: '기간 내 발행제한 수량을 입력하세요',
  ERR_ISSUEPERPERSONLIMIT_0: '기간 내 발행제한 수량은 0으로 입력할 수 없습니다.',
  ERR_ISSUEPERPERSONLIMIT_BETWEEN: '기간 내 발행제한 수량을 쿠폰발행수량 이하로 입력 해 주세요.',
  ERR_DAILYISSUEPERPERSONLIMITCNT_NULL: '1일 내 발행제한 수량을 입력하세요',
  ERR_DAILYISSUEPERPERSONLIMITCNT_0: '1일 내 발행제한 수량은 0으로 입력할 수 없습니다.',
  ERR_DAILYISSUEPERPERSONLIMITCNT_BETWEEN: '1일 내 발행제한 수량을 쿠폰발행수량 이하로 입력 해 주세요',
  ERR_PERPERSONLIMIT_NULL: '1인당 발급수량 제한을 확인 해 주세요',
  ERR_ISSUABLEPLATFORM_NULL: '발급가능 플랫폼을 1개 이상 선택 해 주세요.',
  ERR_DAYSOFWEEK_NULL: '발급가능 요일을 1개 이상 선택 해 주세요.',
  ERR_MINSALE_NULL: '최소기준금액을 입력해 주세요.',
  ERR_GREATERTHEN_9: '기준금액을 10원보다 작게 입력하실 수 없습니다.\n기준금액을 다시 확인해주세요.',
  ERR_MAXSALE_NULL: '최대기준금액을 입력해 주세요.',
  ERR_SALEPRICE_BETWEEN: '최소 기준 금액을 최대 기준 금액보다 작게 입력 해 주세요.',
  ERR_DISCOUNT_NULL: '할인금액을 입력 해 주세요.',
  ERR_DISCOUNT_9: '할인금액을 10원보다 작게 입력하실 수 없습니다.\n할인금액을 다시 확인해주세요.',
  ERR_DISCOUNT_BETWEEN: '할인금액을 할인 기준금액보다 작게 입력해 주세요.',
  ERR_PERCENT_NULL: '정률할인의 할인률을 입력 해 주세요.',
  ERR_PERCENT_0: '할인률을 0%로 입력하실 수 없습니다.',
  ERR_PERCENT_100: '할인률을 100% 초과해서 입력하실 수 없습니다.',
  ERR_MAXDISCOUNT_NULL: '최대 할인금액을 입력하세요.',
  ERR_MAXDISCOUNT_9: '최대 할인금액을 10원보다 작게 입력하실 수 없습니다.\n최대 할인금액을 다시 확인해주세요.',
  ERR_USABLEPLATFORM_NULL: '사용가능 플랫폼을 1개 이상 선택 해 주세요.',
  ERR_USEDAYS_NULL: '사용가능 기간을 선택하세요',
  ERR_PRODUCT_NULL: '쿠폰 적용대상 상품을 추가 해 주세요.',
  ERR_BRAND_NULL: '할인대상 브랜드를 추가 해 주세요.',
  ERR_CATEGORY_NULL: '할인대상 카테고리를 추가 해 주세요.',
  ERR_PARTNER_NULL: '할인대상 파트너를 추가 해 주세요.',
  ERR_EXCLUDE_PRODUCT_NULL: '할인 대상 제외 상품을 추가 해 주세요.',

  ERR_USE_END_1: '사용종료일은 발급기간 후로만 설정 가능합니다.',
  ERR_USE_END_2: '발급종료일은 사용종료일 전으로만 설정 가능합니다.',
});
